export default "__VITE_ASSET__40110f96__"